import React from "react";
import img from "../assets/punchline.png";
import img_mobile from "../assets/punchline_mobile.png";

const Punchline = () => {
  return (
    <div className="relative w-full max-w-screen-2xl mx-auto px-2 sm:px-6 lg:px-8 mt-8 sm:mt-12 lg:mt-24 xl:mt-32">
      {/* Desktop / Tablet Image */}
      <img
        src={img}
        alt="Schooglink Punchline"
        className="hidden sm:block w-full h-auto object-cover rounded-xl shadow-md"
      />

      {/* Mobile Image */}
      <img
        src={img_mobile}
        alt="Schooglink Punchline Mobile"
        className="block sm:hidden w-full h-auto object-cover rounded-lg shadow-sm"
      />

      {/* Mobile Text Overlay */}
      <div className="absolute top-0 left-0 right-0 px-3 sm:hidden">
        <div className="text-white text-center py-4 bg-black/40 rounded-lg mt-3 backdrop-blur-sm">
          <p className="text-sm xs:text-base font-medium leading-relaxed">
            Schooglink delivers affordable and quality education,
            <br /> using an AI-driven hybrid learning model with
            <br /> localized vernacular content, focused on the
            <br /> 255 million K–12 students in rural India.
          </p>
          <h1 className="text-base xs:text-lg sm:text-xl font-bold mt-3">
            ACCESSIBLE | AFFORDABLE | ASPIRATIONAL
          </h1>
        </div>
      </div>

      {/* Desktop / Tablet Text Overlay */}
      <div className="absolute inset-0 hidden sm:flex items-center justify-start px-6 lg:px-12">
        <div className="text-white bg-black/40 p-6 rounded-xl backdrop-blur-sm max-w-[70%] sm:max-w-[60%] lg:max-w-[50%]">
          <p className="text-sm sm:text-base md:text-lg lg:text-xl leading-relaxed">
            Schooglink delivers affordable and quality education using a
            tech-driven, hybrid model of learning with localized vernacular
            content, currently focused on the 255 million K–12 students in rural
            India.
          </p>
          <h1 className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold mt-6">
            ACCESSIBLE | AFFORDABLE | ASPIRATIONAL
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Punchline;
